export const LOGOUT_EVENT = 'logout';
